import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { InterviewSet } from "../../classes/interview_set_class";
import { NewInterview } from "../../classes/new_interview_class";
import { InterviewFormContext } from "../../hooks/InterviewFormContext";
import { InterviewSetShape, NewInterviewShape } from "../../interfaces/classTypes";
import { InterviewNode } from "./InterviewNode";

export const InterviewSelector: React.FunctionComponent = () => {
  const { t, uuid, profileInterviews } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(InterviewFormContext);
  const [selectedSet, setSelectedSet] = useState<InterviewSetShape | null>(
    null
  );
  const dropdownRef = useRef<HTMLSelectElement>();
  const [fullInterviewSet, setFullInterviewSet] = useState<NewInterviewShape[] | null>(null);

  // update available interviews from scheduling tab.
  useEffect(() => {
    let loadedInterviews = profileInterviews.map((id) =>
      NewInterview.find_by_id(id)
    );

    setFullInterviewSet(loadedInterviews);
  }, [profileInterviews]);


  // update selection of interviews in goals dropdown
  // updates whenever the scheduling tab changes the loaded interviews.
  useEffect(() => {
    if (!fullInterviewSet) return;
    let removedSets = goalState.selectedInterviewSets.filter(
      (set) => !fullInterviewSet.find((i) => i.setId == set.id)
    );
    removedSets.forEach((set) => removeSet(set));
  }, [fullInterviewSet]);


  // refreshes the dropdown selections to omit interviews already selected.
  const buildavailableInterviewSet = () => {
    var availableInteviewSet = [];
    fullInterviewSet.forEach((interview) => {
      if (
        !goalState.selectedInterviewSets.find(
          (set) => set.id == interview.setId
        )
      ) {
        availableInteviewSet.push(InterviewSet.find_by_id(interview.setId));
      }
    });
    return availableInteviewSet;
  };


  // render the dropdown selections, taking into account interviews loaded in the scheduling tab 
  // and interviews already selected.
  const dropdownList = () => {
    return buildavailableInterviewSet().map((set) => {
      return (
        <option key={uuid()} id={set.id} value={set.id}>
          {set.name()}
        </option>
      );
    });
  };


 //handle the selection of an interview from the dropdown.
  const handleInterviewSelect = (option) => {
    if (!fullInterviewSet) return;

    let newSet = InterviewSet.find_by_id(option.currentTarget.value);
    option.stopPropagation();
    if (newSet != null) setSelectedSet(newSet);
  };


// handle the adding of the selected interview in the dropdwn.
  const handleAddSelection = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let revisedSelectionList = goalState.selectedInterviewSets;
    if (selectedSet != null) {
      revisedSelectionList.push(selectedSet);
      setGoalState({
        ...goalState,
        selectedInterviewSets: revisedSelectionList,
      });
      setSelectedSet(null);
      dropdownRef.current.value = "";
    }
  };


  // remove interviews sets from the list of selected interview sets.
  const removeSet = (removed) => {
    var newInterviewSet = goalState.selectedInterviewSets.filter(
      (set) => set != removed
    );
    setGoalState((prevState) => {
      return {
        ...prevState,
        selectedInterviewSets: newInterviewSet,
      };
    });
  };


  // render the list of interviews selected to be part of the goal.
  const currentSelectedInterviews = () => {
    return goalState.selectedInterviewSets.map((set) => {
      return <InterviewNode key={uuid()} set={set} handleRemove={removeSet} />;
    });
  };

  return (
    <>
      <div className="goal-boxed-input-area">
        <div className="goal-form-input-row">
          <label
            htmlFor="goal-interview-dropdown"
            className="goal-input-area-title full-width"
          >
            {t("views.goals.headings.select_monitor_program_interviews")}
          </label>
        </div>
        <div
          className="goal-form-input-row"
          role="group"
          id="goal-interview-dropdown"
          aria-label="Basic Example"
          onClick={(e) => e.stopPropagation()}
        >
          <select
            value={selectedSet ? selectedSet.id : ""}
            ref={dropdownRef}
            id="goal-interview-dropdown"
            title="goal-interview"
            className="goal-minimal-dropdown dropdown-feature-length"
            onChange={(e) => {
              handleInterviewSelect(e);
            }}
            onKeyUp={(e) => e.stopPropagation()}
          >
            <option value="" disabled>
              {t("views.goals.headings.select")}
            </option>
            {fullInterviewSet ? dropdownList() : null}
          </select>
          <button
            onClick={handleAddSelection}
            style={{
              border: "none",
              display: selectedSet == null ? "none" : "block",
            }}
          >
            <i className="icon-add add-icon"></i>
          </button>
        </div>
        {currentSelectedInterviews()}
      </div>
    </>
  );
};